module.exports = __webpack_public_path__ + "static/media/arrow-bottom.c2c7d58f.svg";